import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedList from 'I18n/components/FormattedList';
import { TimeZoneStrategyType } from 'automation-ui-flow-core/fields/time/TimeZoneStrategy';
import formatDayOfWeek from 'automation-ui-action-features/components/delay/utils/formatDayOfWeek';
import FormattedTimeDelay from 'automation-ui-action-features/components/delay/FormattedTimeDelay';
import { jsx as _jsx } from "react/jsx-runtime";
export default function getTimeDelayFormatOptions(timeDelay) {
  const {
    daysOfWeek,
    timeOfDay,
    optionalTimeZoneStrategy
  } = timeDelay;
  const isUsingObjectTimezone = optionalTimeZoneStrategy && optionalTimeZoneStrategy.type === TimeZoneStrategyType.ENROLLED_OBJECT;
  return {
    duration: /*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(FormattedTimeDelay, {
        timeDelay: timeDelay
      })
    }),
    dayOfWeek: !daysOfWeek.isEmpty() && /*#__PURE__*/_jsx(FormattedList, {
      exclusive: true,
      children: daysOfWeek.toJS().map(dayOfWeek => /*#__PURE__*/_jsx("strong", {
        children: formatDayOfWeek(dayOfWeek)
      }, dayOfWeek))
    }),
    timeOfDay: timeOfDay && /*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(FormattedDateTime
      // @ts-expect-error the added types for portalTz are missing an override for MomentInput as a parameter
      , {
        value: I18n.moment.portalTz({
          hour: timeOfDay.hour,
          minute: timeOfDay.minute
        })
        /* includes `(Z)` format to disambiguate between timezones with the same abbreviation by showing the UTC offset */,
        format: isUsingObjectTimezone ? 'LT' : 'LT z (Z)'
      })
    })
  };
}